export default __webpack_public_path__ + "static/media/img-ust.d3202547.png";